// extracted by mini-css-extract-plugin
export var buttonContainer = "_5q-1";
export var fontSizeSelect = "_5q-3";
export var formatSelect = "_5q-2";
export var formats = "_5q-4";
export var hidden = "_5q-5";
export var icon = "_5q-6";
export var select = "_5q-0";